import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './EmailLink.css';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Toast from '../Layout/components/Toast';
import ReferralInfo from './components/ReferralInfo';

class EmailLink extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const {
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        return (
            <Root>
                <AppBar position="absolute" color="default">
                    <Toolbar>
                        <div className="logo"></div>
                    </Toolbar>
                </AppBar>
                <div className="content c">
                    <div className="card c">
                        <ReferralInfo></ReferralInfo>
                        {/* <div className="c">
                            <div>img</div>
                            <div>THANK YOU FOR SUBMITTING!</div>
                        </div> */}
                    </div>
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root >
        );
    }
    componentDidMount() {
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    //------------request----------------
}

export default withRouter(EmailLink);